import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import LookupMultiSelect from "@/components/ui/lookup/lookup-multi-select.vue";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";


export default /*#__PURE__*/_defineComponent({
  __name: 'select-contractor-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The boolean flag that specifies whether to use a single lookup or a multi lookup
   * @type {boolean}
   * @default false
   */
  applyLookupSingleSelect: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether to show the search textbox.
   * @type {boolean}
   * @default false
   */
  showSearch: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",

  /**
   * Triggered when one or more contractors are selected in the modal.
   * @property {Object|Object[]} contractor - Returns the selected contractor object when single-select is used,
   * or an array of contractor objects when multi-select is enabled.
   */
  "selectContractor",
],
  setup(__props, { emit }) {

const props = __props;





const selectedContractor = ref(-1);
const selectedContractors = ref<IDDescriptionPair[]>([]);

const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

watch(
  () => showModal.value,
  () => {
    selectedContractor.value = -1;
    selectedContractors.value = [];
  },
);

const onCancelClick = () => (showModal.value = false);

const onSelectClick = () => {
  showModal.value = false;
  if (props.applyLookupSingleSelect) {
    emit("selectContractor", selectedContractor.value);
  } else {
    emit("selectContractor", selectedContractors.value);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
    title: "Contractors",
    width: _unref(ModalWidth).XSmall,
    onModalClosed: _cache[3] || (_cache[3] = ($event: any) => (emit('selectContractor', undefined)))
  }, {
    content: _withCtx(() => [
      (__props.applyLookupSingleSelect)
        ? (_openBlock(), _createBlock(LookupSingleSelect, {
            key: 0,
            modelValue: selectedContractor.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedContractor).value = $event)),
            lookupSource: _unref(LookupTableSource).Contractors,
            showSearch: __props.showSearch
          }, null, 8, ["modelValue", "lookupSource", "showSearch"]))
        : (_openBlock(), _createBlock(LookupMultiSelect, {
            key: 1,
            modelValue: selectedContractors.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedContractors).value = $event)),
            lookupSource: _unref(LookupTableSource).Contractors
          }, null, 8, ["modelValue", "lookupSource"]))
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Select',
          disabled:
            selectedContractors.value.length === 0 && selectedContractor.value === -1,
          onClick: () => {
            onSelectClick();
          },
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})